import "./DesktopEmpty.scss";
import { EventBus } from "../../../eventbus";

export default {
  props: {
    title: String,
    desc: String,
    icon: String,
    button: Object,
    noBg: Boolean,
  },
  methods: {
    gotTo(to) {
      this.$router.push(to);
    },

    emit(name, data) {
      EventBus.$emit(name, data);
    },
  },
};
